import { useState, useEffect } from 'react';
import { getPatientsAndDevicesSafe } from '../services/patientManager';

export interface PatientOption {
  value: string;
  label: string;
  user: {
    id: number;
    email: string;
    first_name: string;
    last_name: string;
    full_name: string;
  };
}

export const usePatients = () => {
  const [patients, setPatients] = useState<PatientOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPatients = async () => {
    setLoading(true);
    setError(null);

    try {
      // Use the safe function from patient manager
      const patientOptions = await getPatientsAndDevicesSafe();
      setPatients(patientOptions);
    } catch (err) {
      console.error('Error fetching patients:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch patients');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPatients();
  }, []);

  return {
    patients,
    loading,
    error,
    refetch: fetchPatients,
  };
};
